// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2C_1H","subheader":"ReorderModal_subheader__3ztzq","listWrap":"ReorderModal_listWrap__2USAu"};